import API from "../api/manager";
import config from "../api/config";

const emudhraCreate = (data) => {
  return API(
    {
      method: "POST",
      url: config.urls.preSign.emudhraCreate,
      data,
    },
    false,
  );
};

const getEsignData = (arbitratorId) => {
  return API(
    {
      method: "GET",
      url: `${config.urls.preSign.getSignIn}/${arbitratorId}`,
    },
    false,
  );
};

const clearEsignData = (arbitratorId) => {
  return API(
    {
      method: "DELETE",
      url: `${config.urls.preSign.clearSignIn}/${arbitratorId}`,
    },
    false,
  );
};

const getBase64 = (id) => {
  return API(
    {
      method: "GET",
      url: `${config.urls.preSign.emudhraBase64}/${id}`,
    },
    false,
  );
};

const clearBase64 = (data) => {
  return API(
    {
      method: "DELETE",
      url: config.urls.preSign.clearBase64,
      data,
    },
    false,
  );
};

const updateEsignedFile = (arbitratorId, data) => {
  return API(
    {
      method: "PUT",
      url: `${config.urls.preSign.updateEsignedFile}/${arbitratorId}`,
      data,
    },
    false,
  );
};

export default {
  emudhraCreate,
  getEsignData,
  clearEsignData,
  getBase64,
  clearBase64,
  updateEsignedFile,
};
